module.exports = __webpack_public_path__ + "static/Circle-of-Care-cabf160455956eaa9e204c720e1fde92.png";